import { render, staticRenderFns } from "./VlLabel.vue?vue&type=template&id=27f778ae&scoped=true&"
import script from "./VlLabel.vue?vue&type=script&lang=js&"
export * from "./VlLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f778ae",
  null
  
)

export default component.exports